import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon, XIcon } from 'lucide-react';
const names = ['Alejandro', 'María', 'Carlos', 'Lucía', 'Fernando', 'Ana', 'Diego', 'Valentina', 'Martín', 'Camila', 'Jorge', 'Sofía', 'Ricardo', 'Paula', 'Nicolás'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 10000);
    // Then repeat every 15-25 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 10000) + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 animate-fade-in-up" data-id="element-221">
      <div className="bg-zinc-900 border border-zinc-800 shadow-2xl rounded-xl p-4 pr-10 flex items-center gap-4 max-w-sm relative" data-id="element-222">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-500 hover:text-zinc-300" data-id="element-223">
          <XIcon className="w-4 h-4" data-id="element-224" />
        </button>

        <div className="bg-amber-500/20 p-2 rounded-full flex-shrink-0" data-id="element-225">
          <ShoppingCartIcon className="w-6 h-6 text-amber-500" data-id="element-226" />
        </div>

        <div data-id="element-227">
          <p className="text-sm text-zinc-300" data-id="element-228">
            <strong className="text-white" data-id="element-229">{currentPurchase.name}</strong> de{' '}
            {currentPurchase.city}
          </p>
          <p className="text-xs text-amber-500 font-medium mt-1" data-id="element-230">
            acaba de adquirir el Sistema Maestro Centenario
          </p>
        </div>
      </div>
    </div>;
}